module.exports = __webpack_public_path__ + "img/024-like.ecda8fcb.svg";